// extracted by mini-css-extract-plugin
export default {"pageNotFound":"PageNotFound_pageNotFound__Y2PQ8"};